import React, { PropsWithChildren } from 'react';
import { BP_CMS_SCREEN_CLASS_NAME } from './Customer/Governance/Components/brandPresenceClasses';

interface IProps extends PropsWithChildren {}

/**
 * A screen a CMS frames on its own, outside the App layout: the Optimize tab of a page, the Content
 * health box beside the editor.
 *
 * The screens are built from the App's components, whose styles apply inside the Brand Presence page
 * container and nowhere else on purpose — the older screens this frame also serves are styled another
 * way and would change under them. A CMS screen is not inside that container, so without this it is
 * drawn from the components' bare markup. Wrapping it puts it inside the scope the same styles apply
 * to, and nothing else: the wrapper carries no layout, size or navigation of its own, so the screen
 * flows at its content's height and the host page's resizer follows it.
 */
export function CmsScreen({ children }: IProps) {
  return <div className={BP_CMS_SCREEN_CLASS_NAME}>{children}</div>;
}
